import { all, call, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { requestPuppy } from '@wix/da-http-client';
import { fakeResponse } from './fakeResponse';
import { unsuggestUser } from './actions';
const logger = ddt.createLogger('suggestions');
function* postRequest(url, data) {
    const response = yield call(requestPuppy, {
        method: 'post',
        url,
        data
    }, fakeResponse(url));
    logger.log('POST:response', response);
    return response;
}
function* handleUnsuggestUser(action) {
    const data = action.payload;
    const response = yield call(postRequest, 'watch/unsuggest', data);
    if (!response || !response.success) {
        logger.error(response.errorDescription);
        return;
    }
}
export default function* userRootSaga() {
    yield all([
        takeEvery(unsuggestUser, handleUnsuggestUser)
    ]);
}

//# sourceMappingURL=saga.js.map